
import {debounceTime} from 'rxjs/operators';
/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/
import { Component, EventEmitter, HostListener, Input, OnChanges, OnDestroy, Output, ViewChild } from '@angular/core';
import { OverlayPanel } from 'primeng/overlaypanel';
import { MenuItem } from 'primeng/api/menuitem';

import { AppUtilityService } from './../../../core/services/app-utility.service';
import { ConfigService } from '../../../core/services/config.service';
import { LmsLoaderService } from '../../../core/services/lms-loader.service';
import { LmsLoggerService } from '../../../core/services/lms-logger.service';
import { LmsRendererService } from '../../../core/services/lms-renderer.service';
import { QueryViewService } from '../../shared/services/query-view.service';
import { QueryViewTrainData } from '../../shared/model/query-view-train-data.model';
import { Router } from '@angular/router';
import { TabSearchParameter } from '../../../core/model/tab-search-parameter.model';
import { TrainData } from '../../../core/model/train-data.model';

/**
 * @export
 * @class QueryViewTrainDataComponent
 * @implements {OnInit}
 * @implements {AfterViewInit}
 * @implements {OnChanges}
 * @implements {OnDestroy}
 */
@Component({
  selector: 'lms-query-view-train-data',
  templateUrl: './query-view-train-data.component.html',
  styleUrls: ['./query-view-train-data.component.scss']
})
export class QueryViewTrainDataComponent implements OnChanges, OnDestroy {
  configData;
  upperHeight = 228;
  scrollHeightTrainTable = (window.innerHeight - this.upperHeight - 60) + 'px';
  scrollWidthTrainTable = (window.innerWidth - 70) + 'px';
  header = '';
  tableRowHeight = 89;
  totalRecords: number;
  rowsPerPage;
  loadingStatus = false;
  isHistorySorted = false;
  isHeaderAdjusted = false;
  currentDateTime = new Date().getTime();
  lastHeight = 0;
  @Input() loadData;
  loadDataToShow: Array<QueryViewTrainData>;
  locoLinks: Array<MenuItem>;
  trainLinks: Array<MenuItem>;
  overlayLinks: Array<MenuItem>;
  overlayPanel: OverlayPanel;
  panelVisible = false;
  contextType: string;
  contextSearchText: string;
  currentContextLoco;
  lazyloadPage = 0;
  lastScrollTop = 0;
  @Output() showLocoMenu: EventEmitter<Map<string, any>> = new EventEmitter<Map<string, any>>();
  @Output() hideContextMenu: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() showTrainMenu: EventEmitter<Map<string, any>> = new EventEmitter<Map<string, any>>();
  @ViewChild('dt', { static: true }) locoDataTable;

  /**
   * Creates an instance of QueryViewTrainDataComponent.
   * @param {ConfigService} configService
   * @param {Router} router
   * @param {LmsLoaderService} lmsLoaderService
   * @param {QueryViewService} queryViewService
   * @param {LmsLoggerService} lmsLoggerService
   * @memberof QueryViewTrainDataComponent
   */
  constructor(private configService: ConfigService, private router: Router, private lmsRendererService: LmsRendererService,
    private lmsLoaderService: LmsLoaderService, private queryViewService: QueryViewService,
    private lmsLoggerService: LmsLoggerService, private appUtilityService: AppUtilityService) {
    this.configData = this.configService.getConfigData();
    this.loadDataToShow = [];
    this.locoLinks = [];
    this.trainLinks = [];
    this.locoLinks.push({ label: 'Data' });
    this.locoLinks.push({ label: 'History' });
    this.locoLinks.push({ label: 'Notes' });
    this.trainLinks.push({ label: 'Data' });
    this.trainLinks.push({ label: 'Profile' });
    this.trainLinks.push({ label: 'History' });
    this.trainLinks.push({ label: 'Notes' });
    const rowCount = this.appUtilityService.getRowPerPageCount(25.6, 223);
    this.rowsPerPage = rowCount < 15 ? 15 : rowCount;
    this.tableRowHeight = 26;
    this.lmsRendererService.resizeObervable.pipe(debounceTime(10)).subscribe((isResize) => {
      if (isResize) {
        this.prepareHeightForPage();
        this.prepareDataList();
      }
    });
  }


  /**
   * every time when input changes and before nginit it fire
   * @memberof QueryViewTrainDataComponent
   */
  ngOnChanges() {
    if (this.loadData && this.loadData.data && this.loadData.data.length > 0) {
      this.prepareDataList();
    } else {
      this.totalRecords = 0;
      this.loadData['data'] = [];
    }
  }

  /**
   * how manyb record are come set in this method
   * @private
   * @memberof QueryViewTrainDataComponent
   */
  private prepareDataList() {
    this.totalRecords = this.loadData.data.length;
  }

  /**
   * THis method navigates to Terminal
   * @param {any} TerminalMnemonic
   * @memberof QueryViewTrainDataComponent
   */
  goToTerminal(TerminalMnemonic) {
    const tabSearchParameter = <TabSearchParameter>({ searchText: TerminalMnemonic });
    
    window.open(
      window.location.href.split('?')[0] + '?type=terminal&subtype=status&search=' + tabSearchParameter.searchText,
      '_blank', "scrollbars=yes,resizable=yes,top=100,left=500,width=1000,height=800"
    );
  }


  /**
   * This method navigates to Train
   * @param {any} TrainMnemonic
   * @memberof QueryViewTrainDataComponent
   */
  goToTrain(TrainMnemonic) {
    const tabSearchParameter = <TabSearchParameter>({ searchText: TrainMnemonic });
    window.open(
      window.location.href.split('?')[0] + '?type=train&subtype=data&search=' + tabSearchParameter.searchText,
      '_blank', "scrollbars=yes,resizable=yes,top=100,left=500,width=1000,height=800"
    );
  }


  /**
   * @memberof QueryViewTrainDataComponent
   */
  ngOnDestroy() {
    this.loadDataToShow = [];
  }

  /**
   * get on which table datatable  created
   * @returns
   * @memberof QueryViewTrainDataComponent
   */

  getTableElement() {
    const locoDataTable = document.getElementById('queryViewTrainResults');
    if (locoDataTable && locoDataTable.children[0] && locoDataTable.children[0].children[0] && locoDataTable.children[0].children[0].children[0]) {
      return locoDataTable.children[0].children[0].children[0];
    }
    return null;
  }

  /**
   * set page height for page
   * @memberof QueryViewTrainDataComponent
   */
  prepareHeightForPage() {
    const windowHeight = this.lmsRendererService.getWindowHeight();
    const windowWidth = this.lmsRendererService.getWindowWidth();

    let heightToAdjust = 0;
    if (windowWidth < 1344) {
      heightToAdjust = 34;
    } else if (windowWidth < 1758) {
      heightToAdjust = 17;
    }
    let ifScrollWidth = 0;
    if (windowWidth && windowWidth < 1280) {
      ifScrollWidth = 21;
      this.scrollHeightTrainTable = (windowHeight - 278 - ifScrollWidth - heightToAdjust) + 'px';
    } else {
      this.scrollHeightTrainTable = (windowHeight - 278 - ifScrollWidth - heightToAdjust) + 'px';
      ifScrollWidth = 0;
    }

    this.scrollWidthTrainTable = (window.innerWidth - 70) + 'px';
  }

  /**
   * download train excel data
   * @memberof QueryViewTrainDataComponent
   */
  downloadTrainExcel() {
    const dataToExport = this.locoDataTable.filteredValue === undefined ? this.loadData.data : this.locoDataTable.filteredValue;
    for(let i=0;i<dataToExport.length;i++) {
      let item = dataToExport[i];
      item.oprtngRegion = item.oprtngRegionName;
      item.oprtngZone = item.oprtngZoneName;
    }
    this.queryViewService.excelTrainDownload(dataToExport);
  }

  /**
   * This shows Train Context Menu
   * @param {TrainData} train
   * @memberOf LmsTerminalBoundComponent
   */
  public showTrainContextMenu(train: TrainData, index: string) {
    const trainMenu = new Map<string, any>();
    if (train && train.trainIdentifier && train.trainIdentifier.length > 4) {
      trainMenu.set('trainData', train);
      trainMenu.set('trainId', 'train' + index + this.header + train.trainIdentifier);
      this.showTrainMenu.emit(trainMenu);
    }
  }

  /**
   * This method is used to close the context panel
   * of train or locomotive
   * @memberOf LmsTerminalBoundComponent
   */
  public hideLocoTrainContextPanel() {
    this.hideContextMenu.emit(true);
  }

  /**
   * @param {any} LocoMnemonic
   * @memberof QueryViewTrainDataComponent
   */
  goToLoco(LocoMnemonic) {
    // this.appUtilityService.navigateByUrl('locomotive', 'data', LocoMnemonic, true);
    const tabSearchParameter = <TabSearchParameter>({ searchText: this.appUtilityService.UIformatLocomotiveId(LocoMnemonic) });
    window.open(
      window.location.href.split('?')[0] + '?type=locomotive&subtype=data&search=' + tabSearchParameter.searchText,
      '_blank', "scrollbars=yes,resizable=yes,top=100,left=500,width=1000,height=800"
    );
  }

  /**
   * @param {string} type
   * @memberof QueryViewTrainDataComponent
   */
  setOverlayLinks(type: string) {
    this.checkForOverlayPanelVisibility();
    if (type === 'loco') {
      this.overlayLinks = this.locoLinks;
    } else if (type === 'train') {
      this.overlayLinks = this.trainLinks;
    }
  }

  /**
   * @param {any} event
   * @param {OverlayPanel} panel
   * @param {any} alert
   * @param {string} obj
   * @returns
   * @memberof QueryViewTrainDataComponent
   */
  public locomotiveOverlayPosition(event, panel: OverlayPanel, alert, obj: string) {
    this.overlayPanel = panel;
    if (!panel.overlayVisible && this.panelVisible === true) {
      this.panelVisible = false;
    }
    if (this.panelVisible) {
      panel.hide();
      this.panelVisible = false;
      event.stopPropagation();
      return;
    }
    const overlayPanel = document.getElementById('overlayLinksInfo').getElementsByClassName('p-overlaypanel');
    let element;
    if (obj === 'loco') {
      element = document.getElementById('locomotive' + alert.locomotiveId).parentElement;
      this.contextType = 'Locomotive';
      this.contextSearchText = alert.locomotiveId;
    } else if (obj === 'train') {
      element = document.getElementById('train' + alert.indexPosition + alert.trainId).parentElement;
      this.contextType = 'Train';
      this.contextSearchText = alert.trainId;
    }
    panel.show(event);
    const rect = element.getBoundingClientRect();
    const scrollHeight = window.pageYOffset;
    const windowHeight = window.innerHeight;
    let overlayHeight = 0;
    if (this.overlayLinks && this.overlayLinks.length > 0) {
      overlayHeight = this.overlayLinks.length * 30;
    } else {
      panel.hide();
      return;
    }
    let top;
    if ((windowHeight - rect.top - rect.height) > overlayHeight) {
      top = rect.top + rect.height + scrollHeight + 'px';
    } else {
      top = (rect.top - overlayHeight) + scrollHeight + 'px';
    }
    const left = rect.left + 'px';
    const width = rect.width + 'px';
    let style = `display: block; z-index: 1001; visibility: visible; 
            opacity: 1.032; top: <<top>>; left: <<left>>; width: <<width>>;`;
    style = style.replace('<<top>>', top);
    style = style.replace('<<left>>', left);
    style = style.replace('<<width>>', width);
    overlayPanel[0].setAttribute('style', style);
    event.stopPropagation();
    this.panelVisible = true;
    this.currentContextLoco = alert;
  }

  /**
   * @param {any} event
   * @param {OverlayPanel} panel
   * @returns
   * @memberof QueryViewTrainDataComponent
   */
  public hideOverlayPanel(event, panel: OverlayPanel) {
    this.checkForOverlayPanelVisibility();
    if (this.panelVisible) {
      panel.hide();
      this.panelVisible = false;
      panel = null;
      this.currentContextLoco = null;
      return;
    }
  }

  /**
   * @param {any} event
   * @memberof QueryViewTrainDataComponent
   */
  @HostListener('document:click') hideAddTabPanel(event) {
    this.checkForOverlayPanelVisibility();
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  /**
   * @memberof QueryViewTrainDataComponent
   */
  checkForOverlayPanelVisibility() {
    if (this.overlayPanel) {
      this.overlayPanel.hide();
      this.currentContextLoco = null;
      this.overlayPanel = null;
      this.contextType = null;
      this.contextSearchText = null;
      this.overlayLinks = null;
    }
  }

  /**
   * @param {string} subType
   * @param {string} type
   * @param {string} searchText
   * @memberof QueryViewTrainDataComponent
   */
  public routeToPage(subType: string, type: string, searchText: string) {
    const tabSearchParameter = <TabSearchParameter>({ searchText: searchText });
    // Story #6 - Code to open Train Data in new window
    window.open(
      window.location.href.split('?')[0] + '?type='+type.toLowerCase() +'&subtype=' + subType.toLowerCase() + '&search=' + tabSearchParameter.searchText,
        '_blank', "scrollbars=yes,resizable=yes,top=100,left=500,width=1000,height=800"
      );
  }

  /**
   * set page height when page size changes
   * @param {*} directiveElement
   * @returns
   * @memberof QueryViewTrainDataComponent
   */
  setHeight(directiveElement: any) {
    const heightArray = [];
    let lastVal = (this.lazyloadPage * this.tableRowHeight);
    const childElements = directiveElement.querySelectorAll(`tr`);
    const childElementsLength = childElements.length;
    for (let i = 0; i < childElementsLength; i++) {
      lastVal += childElements[i].getBoundingClientRect().height;
      heightArray.push(lastVal);
    }
    this.lastScrollTop = heightArray[heightArray.length - 1];
    return heightArray;
  }

}